import { ValidationFunction } from './Validator.interface'

export const IsMatchingRegexpValidator =
  (pattern: RegExp, error: string): ValidationFunction =>
  (value) => {
    if (!value) {
      return ''
    }

    if (!pattern.test(value.toString())) {
      return error
    }
    return ''
  }
